document.addEventListener("DOMContentLoaded", () => {
    const carousels = document.querySelectorAll(
        ".carousel-post-type .swiper"
    );

    carousels.forEach((carousel) => {
        const paginationEl = carousel.querySelector(".swiper-pagination");
        const carouselContainer = carousel.closest(".carousel-post-type");
        const isProyecto = carouselContainer.classList.contains("carousel-post-type--proyecto");
        const isPost = carouselContainer.classList.contains("carousel-post-type--post");
        const isMobile = window.matchMedia("(max-width: 767px)").matches;

        let swiperConfig = {
            slidesPerView: "auto",
            setWrapperSize: true,
        };

        if (isMobile) {
            // En móvil: navegación forzada, sin paginación
            swiperConfig.navigation = {
                nextEl: carousel.querySelector(".swiper-button-next"),
                prevEl: carousel.querySelector(".swiper-button-prev"),
            };
        } else {
            // En desktop: paginación normal, sin navegación
            if (paginationEl) {
                swiperConfig.pagination = {
                    el: paginationEl,
                    clickable: true,
                };
            }
        }

        const swiperInstance = new Swiper(carousel, swiperConfig);

        // Filtrado para proyectos
        if (isProyecto) {
            const filterButtons = carouselContainer.querySelectorAll('.project-filter__btn');
            
            if (filterButtons.length > 0) {
                filterButtons.forEach(button => {
                    button.addEventListener('click', () => {
                        const category = button.dataset.category;
                        
                        // Actualizar botones activos
                        filterButtons.forEach(btn => btn.classList.remove('active'));
                        button.classList.add('active');
                        
                        // Filtrar slides
                        const slides = carousel.querySelectorAll('.swiper-slide');
                        let visibleCount = 0;
                        
                        slides.forEach(slide => {
                            if (category === 'all') {
                                slide.style.display = '';
                                visibleCount++;
                            } else {
                                // Verificar si el slide tiene la clase de la categoría
                                if (slide.classList.contains(category)) {
                                    slide.style.display = '';
                                    visibleCount++;
                                } else {
                                    slide.style.display = 'none';
                                }
                            }
                        });
                        
                        // Actualizar swiper para recalcular slides visibles
                        setTimeout(() => {
                            swiperInstance.update();
                            if (visibleCount > 0) {
                                swiperInstance.slideTo(0, 300); // Volver al inicio con animación suave
                            }
                        }, 50);
                    });
                });
            }
        }
    });
});
